export enum QueryKeys {
    useClients = 'useClients',
    useExperiences = 'useExperiences',
    useCaseStudies = 'useCaseStudies',
}

export type ValidQueryKey = `${QueryKeys}`;
